import { FormGroup } from '@angular/forms';
import { RadioCheckBoxEnum } from '../radio.checkbox.enums';

/** Partie de TypeIndexation manipulée par ce helper (typage structurel : évite un import circulaire). */
export interface CriteresIndexation {
  criteresSociaux?: string;
  criteresEnvironnementaux?: string;
}

/**
 * PRB0052504 — source unique du défaut des critères sociaux et environnementaux.
 *
 * Ces deux critères sont obligatoires (règle 'required' dans le gabarit) et doivent donc toujours
 * présenter un bouton radio coché. À défaut de valeur saisie ou héritée (avis neuf, avis lié sans
 * la donnée, gabarit national où la valeur vaut '' ou null), on les positionne à 'Non'.
 *
 * La règle est appliquée à trois endroits — le composant de saisie et les deux extracteurs
 * (eForms et national) — et le modèle TypeIndexation s'initialise sur la même constante.
 * Tout passe par ici pour qu'une dérive entre copies redevienne impossible : c'est exactement
 * une telle dérive (criteresEnvironnementaux oublié) qui a produit le bug corrigé par cette MR.
 */
export class CriteresIndexationHelper {

  /** Valeur posée quand le critère n'est ni saisi ni hérité. */
  public static readonly CRITERE_DEFAUT = RadioCheckBoxEnum.nonValue;

  public static readonly CTRL_CRITERES_SOCIAUX = '_SepSep_TypeIndexation_SepAtt_criteresSociaux';
  public static readonly CTRL_CRITERES_ENVIRONNEMENTAUX = '_SepSep_TypeIndexation_SepAtt_criteresEnvironnementaux';

  /**
   * Positionne les deux critères à 'Non' lorsqu'ils sont vides, sur le modèle et — si les
   * FormControl existent déjà — sur le formulaire.
   *
   * Les deux écritures sont nécessaires et ne sont pas redondantes :
   * - l'affectation sur le modèle est ce qui agit quand les FormControl n'existent pas encore
   *   (cas du ngOnInit du composant parent, qui précède celui des app-form-input enfants) ;
   * - le setValue est ce qui agit quand les FormControl existent déjà (ngOnChanges, extracteurs).
   *   On passe bien par setValue et non par une écriture directe de .value, pour rejouer les
   *   validateurs, remonter la validité au FormGroup parent et recocher le radio à l'écran.
   *
   * Ne surtout pas « simplifier » en supprimant l'une des deux.
   *
   * @param indexation modèle à compléter ; un indexation null/undefined est ignoré silencieusement
   *                   (le stepper positionne indexation à null lorsque fadIndex vaut 1).
   * @param form formulaire porteur des deux FormControl, s'ils sont déjà créés.
   */
  public static applyDefaults(indexation: CriteresIndexation, form?: FormGroup): void {
    if (!indexation) {
      return;
    }
    if (!indexation.criteresSociaux) {
      indexation.criteresSociaux = CriteresIndexationHelper.CRITERE_DEFAUT;
      form?.controls[CriteresIndexationHelper.CTRL_CRITERES_SOCIAUX]?.setValue(CriteresIndexationHelper.CRITERE_DEFAUT);
    }
    if (!indexation.criteresEnvironnementaux) {
      indexation.criteresEnvironnementaux = CriteresIndexationHelper.CRITERE_DEFAUT;
      form?.controls[CriteresIndexationHelper.CTRL_CRITERES_ENVIRONNEMENTAUX]?.setValue(CriteresIndexationHelper.CRITERE_DEFAUT);
    }
  }
}
